var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.caseSchillerPropertyValueIndexData[0].data.length)?_c('VueApexCharts',{staticStyle:{"width":"100%"},attrs:{"type":"area","height":"400","options":_vm.caseSchillerPropertyValueIndexChartOptions,"series":_vm.caseSchillerPropertyValueIndexData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }